import React from 'react'

const PrimaryMFSIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect
                x="5"
                y="2"
                width="14"
                height="20"
                rx="2"
                stroke="#E07839"
                strokeWidth="2"
            />
            <path
                d="M12 18H12.01"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <path
                d="M9 6H15"
                stroke="#E07839"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <circle
                cx="12"
                cy="11"
                r="2"
                stroke="#E07839"
                strokeWidth="2"
            />
        </svg>
    )
}

export default PrimaryMFSIcon

